import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=45a2e774&scoped=true"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=ts"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=ts"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=45a2e774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2e774",
  null
  
)

export default component.exports